"use client";

import ArrowForward from "@/assets/vectors/ArrowForward";
import Button from "@/components/button/Button";
import Project from "@/types/Project";
import dictionary from "@/utils/dictionary";
import { calculateReadingTime } from "@/utils/readingTime";
import Image from "next/image";
import styles from "./case_study_card.module.scss";

interface CaseStudyCardProps {
    project: Project;
    index: number;
}

export default function CaseStudyCard({ project, index }: CaseStudyCardProps) {
    const caseStudy = project.case_study!;
    return (
        <article
            className={styles.card}
            data-scroll-animation="come-from-bottom"
            data-scroll-animation-delay={index * 75}
            style={{
                '--color1': project.colors[0],
                '--color2': project.colors[1],
            } as React.CSSProperties}
        >
            <div className={styles.header}>
                <div className={styles.image_container}>
                    <Image
                        src={caseStudy.thumbnail_image}
                        alt={dictionary.alts.project_logo.replace("{{project_name}}", caseStudy.project_name)}
                        className={styles.thumbnail_image}
                        width={120}
                        height={120}
                        sizes="120px"
                        quality={80}
                    />
                </div>

                <div className={styles.header_text}>
                    <h3 className={styles.title}>{caseStudy.project_name} <span className={styles.hero_title}>{caseStudy.hero_title}</span></h3>
                    <p className={styles.subtitle}>{caseStudy.hero_subtitle}</p>
                </div>
            </div>

            <div className={styles.meta}>
                <div className={styles.meta_item}>
                    <span className={styles.label}>Role</span>
                    <span className={styles.value}>{caseStudy.overview.role}</span>
                </div>
                <div className={styles.meta_item}>
                    <span className={styles.label}>Duration</span>
                    <span className={styles.value}>{project.started_date} — {project.ended_date || dictionary.global.present}</span>
                </div>
                <div className={styles.meta_item}>
                    <span className={styles.label}>Read Time</span>
                    <span className={styles.value} dangerouslySetInnerHTML={{ __html: calculateReadingTime(caseStudy) }} />
                </div>
                <div className={styles.meta_item}>
                    <span className={styles.label}>Platforms</span>
                    <span className={styles.value}>{caseStudy.overview.platforms.join(", ")}</span>
                </div>
            </div>

            <div className={styles.button_container}>
                <Button
                    label="Read Full Case Study"
                    href={`/case-study/${caseStudy.slug}`}
                    size="large"
                    endIcon={ArrowForward}
                    iconSize={17}
                    className={styles.button}
                />
            </div>
        </article>
    );
}
